import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { MapHelperService } from "src/services/map-helper.service";
import { IconLoadMapService } from "src/services/maps/features/IconLoad-Map.service";
import { AllowedDTO } from "../utils/models/allowedDTO";
import { LocalStorageService } from "src/app/features/shared/services/LocalStorage.service";
import { LocationCategoryDTO } from "src/app/features/map-features/sections/locations-section/models/LocationCategoryDTO";

@Injectable({
    providedIn: "root",
})
export class MapRestrictionsService {

    public allowedParts$: BehaviorSubject<AllowedDTO> = new BehaviorSubject<AllowedDTO>(null);

    constructor(
        private localStorageService: LocalStorageService,
    ) {}

    isCategoryAllowed(categoryId: string): boolean {
        const allowedParts = this.allowedParts$.getValue();
        if (!allowedParts || !allowedParts.allowedCategories) {
            return false; 
        }

        const isAllowed = allowedParts.allowedCategories.includes(categoryId);
        if(!isAllowed){
            const category = JSON.parse(this.localStorageService.getListaCategorias())?.find(cat => cat.id == categoryId) as LocationCategoryDTO;
            // console.log("Category not allowed:", category, categoryId, JSON.parse(this.localStorageService.getListaCategorias()));
            if(category.itWorksAsGPS && this.isGPSAllowed()) {
                return true;
            }
        }
        return isAllowed;
    }

    isGPSAllowed(): boolean {
        const allowedParts = this.allowedParts$.getValue();
        if (!allowedParts || !allowedParts.allowedCategories) {
            return false; 
        }
        return allowedParts.allowedCategories.includes("gps");
    }
}
